// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__XBwQj","avatar":"Avatar_avatar__qbz0B","avatar__edit":"Avatar_avatar__edit__jU+2P","avatar__edit__icon":"Avatar_avatar__edit__icon__dgZKh"};